import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './authUnavailable.css';

const LOGO = `${process.env.PUBLIC_URL}/g2-logo.png`;

const AuthUnavailable = () => (
  <div className="authunavailable surface-game">
    <Helmet>
      <title>Sign-in unavailable · Groupardy</title>
      <meta name="robots" content="noindex, follow" />
      <meta name="theme-color" content="#1a1a2e" />
    </Helmet>

    <main className="au-stage">
      <a className="au-brand" href="/" aria-label="Groupardy home">
        <img src={LOGO} alt="Groupardy" />
      </a>

      <h1 className="au-title">Sign-in is unavailable</h1>
      <p className="au-body">
        We couldn't reach the sign-in service. This can happen on preview links,
        or if your browser is blocking third-party storage. You can still play
        and create games without signing in.
      </p>

      <div className="au-actions">
        <button
          type="button"
          className="au-btn au-btn-primary"
          onClick={() => window.location.reload()}
        >
          Try Again
        </button>
        <Link className="au-btn au-btn-ghost" to="/">
          Go Home
        </Link>
      </div>
    </main>
  </div>
);

export default AuthUnavailable;
